import create from 'zustand'
import { persist } from 'zustand/middleware'

import type { State } from 'zustand'

interface MilMaterialScroll {
  moduleId: number
  scrollPos: number
}

interface MilMaterialTabState extends State {
  openedTab: number[]
  scrollRecords: MilMaterialScroll[]
  toggleOpenedTab: (tabId: number) => void
  setScrollPosition: (moduleId: number, scrollPost: number) => void
}

export const useMilMaterialTabStore = create<MilMaterialTabState>(
  persist(
    (set) => ({
      scrollRecords: [],
      openedTab: [],
      toggleOpenedTab: (tabId: number) => {
        set((state) => {
          if (
            state.openedTab.findIndex((id) => {
              return id === tabId
            }) < 0
          ) {
            return {
              openedTab: [...state.openedTab, tabId],
            }
          } else {
            return {
              openedTab: state.openedTab.filter((id) => {
                return id !== tabId
              }),
            }
          }
        })
      },
      setScrollPosition: (moduleId: number, scrollPosition: number) => {
        set((state) => {
          return {
            scrollRecords: [
              ...state.scrollRecords.filter((module) => {
                return moduleId !== module.moduleId
              }),
              {
                moduleId: moduleId,
                scrollPos: scrollPosition,
              },
            ],
          }
        })
      },
    }),
    {
      name: 'microlearning-material-tab',
    }
  )
)

interface IModuleExpanderStore extends State {
  setLastExpandedIds: (indexes: string[]) => void
  lastExpandedIds: string[]
}
export const useModuleExpanderStore = create<IModuleExpanderStore>(
  persist(
    (set) => ({
      lastExpandedIds: [],
      setLastExpandedIds: (indexes: string[]) => {
        set({ lastExpandedIds: indexes })
      },
    }),
    {
      name: 'microlearning-module-expander',
      version: 1,
    }
  )
)

interface ITestingVariantStore extends State {
  variant: string
  setVariant: (variant: string) => void
}
export const useTestingVariantStore = create<ITestingVariantStore>(
  persist(
    (set) => ({
      variant: 'baseline',
      setVariant(value: string) {
        set({ variant: value })
      },
    }),
    {
      name: 'microlearning-test-variant',
      version: 0,
    }
  )
)
